import axios from '../utils/AxiosInstance'

export default {
  // namespaced: true,
  state: {
    tags: {
      selectIds: [],
      filters: {},
      paginate: {},
      selectId: false
    }
  },
  mutations: {
    SET_TAG_SELECT_IDS (store, ids) {
      store.tags.selectIds = ids
    },
    REMOVE_TAG_SELECT_IDS (store, ids) {
      store.tags.selectIds = store.tags.selectIds.filter((v) => { return !ids.includes(v) })
    },
    SET_TAG_SELECT_ID (store, id) {
      store.tags.selectId = id
    },
    SET_TAG_FILTERS (store, filters) {
      store.tags.filters = filters
    },
    SET_TAG_PAGINATE (store, val) {
      store.tags.paginate = {
        limit: val.limit,
        page: val.page,
        pages: val.pages,
        total: val.total
      }
    }
  },
  getters: {
    getTags: (store, getters) => {
      return store.tags.selectIds.map((id) => {
        return getters['entities/tags/find'](id)
      })
    },
    getTagsFilters: (store, getters) => {
      return store.tags.filters
    },
    getTagsPaginate: (store, getters) => {
      return store.tags.paginate
    },
    getTag: (store, getters) => {
      return getters['entities/tags/find'](store.tags.selectId) || {}
    }
  },
  actions: {
    /*
    selectTags
    */
    selectTags ({commit, dispatch, getters, state}, filters) {
      return dispatch('getTags', filters)
      .then((response) => {
        commit('SET_TAG_FILTERS', filters)
        commit('SET_TAG_PAGINATE', response)
        commit('SET_TAG_SELECT_IDS', response.docs.map((item) => { return item._id }))
        return response
      })
    },
    /*
    refreshSelectTags
    */
    refreshSelectTags ({commit, dispatch, getters, state}) {
      return dispatch('selectTags', getters.getTagsFilters)
    },
    /*
    selectTag
    */
    selectTag ({commit, dispatch, getters, state}, id) {
      return dispatch('getTagById', id)
      .then((response) => {
        commit('SET_TAG_SELECT_ID', response._id)
        return response
      })
    },
    /*
    getTags
    */
    getTags ({commit, dispatch, getters, state}, filters) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/tags/${filters.type}`, {params: filters})
      .then((response) => {
        return dispatch('entities/tags/insert', {
          data: response.data.docs
        })
        .then((result) => {
          return {
            docs: result.tags || [],
            limit: response.data.limit,
            page: response.data.page,
            pages: response.data.pages,
            total: response.data.total
          }
        })
      })
    },
    /*
    getTagById
    */
    getTagById ({commit, dispatch, getters, state}, data) {
      return axios
      .get(`/accounts/${getters.getAccount._id}/tags/${data.type}/${data.id}`)
      .then((response) => {
        return dispatch('entities/tags/insert', {
          data: response.data
        })
      })
      .then((result) => {
        return result.tags[0]
      })
    },
    /*
    createTag
    */
    createTag ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .post(`/accounts/${getters.getAccount._id}/tags/${data.type}`, data)
      .then((response) => {
        return dispatch('entities/tags/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.tags[0]
      })
    },
    /*
    updateTag
    */
    updateTag ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/tags/${data.type}/${data._id}`, data)
      .then((response) => {
        return dispatch('entities/tags/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.tags[0]
      })
    },
    /*
    mergeTags
    */
    mergeTags ({commit, dispatch, getters, state}, data) {
      delete data.$id

      return axios
      .put(`/accounts/${getters.getAccount._id}/tags/${data.type}/merge`, { tags: data.tags })
      .then((response) => {
        return dispatch('entities/tags/insert', {
          data: response.data
        })
      })
      .then((response) => {
        return response.tags[0]
      })
    },
    /*
    deleteTag
    */
    deleteTag ({commit, dispatch, getters, state}, data) {
      return axios
      .delete(`/accounts/${getters.getAccount._id}/tags/${data.type}/${data.id}`)
      .then((response) => {
        commit('REMOVE_TAG_SELECT_IDS', [data.id])
        dispatch('entities/tags/delete', data.id)
        return {}
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Tag.js